const MONTH_KEYS = ['jan', 'feb', 'mar', 'apr', 'may', 'jun', 'jul', 'aug', 'sep', 'oct', 'nov', 'dec'];

export function formatCurrency(amount, locale = 'fr', currency = 'RWF') {
  const number = Number(amount) || 0;
  const formatter = new Intl.NumberFormat(locale === 'fr' ? 'fr-RW' : 'en-RW', {
    maximumFractionDigits: 0,
  });
  return `${formatter.format(number)} ${currency}`;
}

export function formatNumber(value, locale = 'fr') {
  const number = Number(value) || 0;
  return new Intl.NumberFormat(locale === 'fr' ? 'fr-RW' : 'en-RW').format(number);
}

export function formatDate(value, t) {
  if (!value) return '';
  const date = value instanceof Date ? value : new Date(value);
  if (Number.isNaN(date.getTime())) return '';
  const day = date.getDate();
  const monthShort = t(`months.short.${MONTH_KEYS[date.getMonth()]}`);
  return `${day} ${monthShort} ${date.getFullYear()}`;
}

export function formatDateInput(value) {
  if (!value) return '';
  const date = value instanceof Date ? value : new Date(value);
  if (Number.isNaN(date.getTime())) return '';
  const month = String(date.getMonth() + 1).padStart(2, '0');
  const day = String(date.getDate()).padStart(2, '0');
  return `${date.getFullYear()}-${month}-${day}`;
}

export function formatRelativeTime(value, t) {
  if (!value) return '';
  const date = value instanceof Date ? value : new Date(value);
  if (Number.isNaN(date.getTime())) return '';
  const diffMs = Date.now() - date.getTime();
  const minutes = Math.floor(diffMs / 60000);
  if (minutes < 1) return t('time.just_now');
  if (minutes < 60) return t('time.minutes_ago', { count: minutes });
  const hours = Math.floor(minutes / 60);
  if (hours < 24) return t('time.hours_ago', { count: hours });
  const days = Math.floor(hours / 24);
  if (days === 1) return t('time.yesterday');
  if (days < 7) return t('time.days_ago', { count: days });
  return formatDate(date, t);
}

export function initialsOf(...names) {
  return names
    .filter(Boolean)
    .map((n) => String(n).trim().charAt(0).toUpperCase())
    .join('')
    .slice(0, 2);
}

export function classNames(...parts) {
  return parts.filter(Boolean).join(' ');
}

export function generateId(prefix, current) {
  const next = String((current || 0) + 1).padStart(4, '0');
  return `${prefix}-${next}`;
}

export function payerLabel(payment, memberById) {
  if (!payment) return '—';
  if (payment.memberId) {
    const member = memberById ? memberById(payment.memberId) : null;
    if (member) return `${member.firstName} ${member.lastName}`;
  }
  if (payment.payerName) return payment.payerName;
  return '—';
}

export function downloadJSON(filename, data) {
  const blob = new Blob([JSON.stringify(data, null, 2)], { type: 'application/json' });
  const url = URL.createObjectURL(blob);
  const a = document.createElement('a');
  a.href = url;
  a.download = filename;
  a.click();
  URL.revokeObjectURL(url);
}
